export default {
    data() {
        return {
            notifications: [],
            notificationIdCounter: 0
        }
    },
    methods: {
        showAlertMessage(text, type = 'info', duration = 5000) {
            const notification = {
                id: ++this.notificationIdCounter,
                text: text,
                type: type
            };
            
            this.notifications.push(notification);
            
            setTimeout(() => {
                const index = this.notifications.findIndex(n => n.id === notification.id);
                if (index > -1) {
                    this.notifications.splice(index, 1);
                }
            }, duration);
        },
        clearAllNotifications() {
            this.notifications = [];
        }
    }
}


// WEBPACK FOOTER //
// ./src/Assets/mixins/notifications.js